export default function snapToGrid(x,y) {
	const snappedX = Math.round(x / 32) * 32
	const snappedY = Math.round(y / 32) * 32
	return [snappedX, snappedY]
}


// WEBPACK FOOTER //
// ./src/view/print/paperconfig/snapToGrid.js